<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"

          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
   
     val: [],
     modalCreate: "product",
     fields: [
         {
              label: "Название",
              key: "title",
              type: "field",
              textType: "text", 
              isMultiLang:true
      },
      {
        col:' col-12 col-md-12',
        key: "categories",
        label: "Категории (тут оставим?)",
        type: "selects",
        selectKey: "title",
        modal: "category",
      },
      {
        col:' col-12 col-md-12',
        key: "brand",
        label: "Бренд",
        type: "select",
        selectKey: "name",
        modal: "brand",
      },
      {
        col:' col-12 col-md-12',
        key: "name",
        label: "Класс",
        type: "select",
        selectKey: "title",
        modal: "name",
      },

      {
        key: "vendor_code",
        label: "Артикул (группа)",
        type: "field",
        textType: "text",
      },
    ],
      /** APIs */
      removeLink: "",
      cardLink: "item_product",
      itemLink: "warehouse/products",
      setLink: "warehouse/products",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
        {
          key: "display_name",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "brand",
          title: "Бренд",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          object: 'name',
        },
        {
          key: "name",
          title: "Класс",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          object: 'title',
        },
        {
          key: "vendor_code",
          title: "Артикул (группа)",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
